import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { SessionService } from '../session/session.service';
import { GameInfo } from '../../domain/signals/game-info';
import { WinningPlan } from '../../domain/winning-plan';
import { isNullOrUndefined } from 'util';
import { SystemConfig } from '../../config/system-config';

@Injectable()
export class WinningPlanService {

    constructor(public sessionService: SessionService,
                public http: Http) {
    }

    public fetchWinningPlan() {
        let headers: Headers = new Headers();
        this.http.get(SystemConfig.Endpoint.WINNING_PLAN, {
            headers: headers
        }).subscribe((res: Response) => {
            if (res.json().length > 0) {
                this.sessionService.winningPlan = this.map(res.json());
            } else {
                setTimeout(() => this.fetchWinningPlan(), 10000);
            }
        });
    }

    public map(json: any[]): WinningPlan[] {
    let winningPlan: WinningPlan[] = [];
    json.forEach((el: any, idx: number) => {
      let wp: WinningPlan = new WinningPlan();
      wp.amount = idx;
      for (let i = 0; i <= idx; i++) {
        let odd: number = el[i.toString()];
        if (!isNullOrUndefined(odd)) {
          wp.prices.push(new WinningPlan.Price(i, odd));
        }
      }
      if (wp.prices.length > 0) {
        winningPlan.push(wp);
      }
    });
    return winningPlan;
  }

}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/shared/services/winning-plan/winning-plan.service.ts